import $ from 'jquery';

/**
 *
 * @param {string} className
 */
const removeFontAwesomeIcon = (className) => {
    return className
        .split(' ')
        .filter(className => className.startsWith('fa-'))
        .join(' ');
};

$(() => {
    $('.js-spinner').on('click', (e) => {
        let $button = $(e.currentTarget);

        $button.find('.js-spinner-icon')
            .removeClass((i, className) => removeFontAwesomeIcon(className))
            .addClass('fa-circle-notch fa-spin');

        $button.find('.js-spinner-text').text('Παρακαλώ περιμένετε...');
    });
});
